import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {Metadata} from '../core/entity/core.entity.metadata';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {FieldModelXrefEntity} from './field.model.xref.entity';

@EntityTable('model', 'f9b070ee-daa1-4a14-922e-62cfcd8d625d')
export class ModelEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.STRING)
    public tableName: string;

    @Column(FieldTypeKind.GUID)
    public ownerId: string;

    @Column(FieldTypeKind.LONG)
    public version: number;

    @Column(FieldTypeKind.ANY, true)
    public settings: any;

    @Transient()
    @Column(FieldTypeKind.VIRTUAL)
    public metadata: Metadata;

    @Transient('field_model_xref', FieldRelationKind.HAS_MANY, 'modelId', 'aliasId', 'aliasId')
    public fields: FieldModelXrefEntity[];

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

}
